import React from 'react'
import { useAddCity } from '../../hooks/useCity';
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { useCountry } from '../../hooks/useCountry';
import Select from 'react-select';

function CityForm({ open, onClose, formData, onInputChange }) {
  const { mutate: addCity } = useAddCity();
  const { data: countriesData } = useCountry();

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      addCity(formData);
      onClose();
    } catch (error) {
      console.error("Error adding Country:", error);
    }
  };

  // Reusable styles for Select components
  const selectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: state.isFocused ? "2px solid #159bd7" : "1px solid #d1d5db",
      borderRadius: "0.375rem",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(21, 155, 215, 0.2)" : "none",
      "&:hover": {
        border: "1px solid #159bd7",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#159bd7"
        : state.isFocused
          ? "#f3f4f6"
          : "white",
      color: state.isSelected ? "white" : "#374151",
      "&:hover": {
        backgroundColor: state.isSelected ? "#159bd7" : "#f3f4f6",
      },
    }),
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle className="bg-blueColor text-white py-4">
          <i className="fas fa-plus text-xl mx-2"></i>
          <span className="text-xl font-semibold">Add New City</span>
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent className="mt-4">
            <div className="grid grid-cols-1 gap-4 p-4">
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Name
                </label>
                <input
                  name="name"
                  value={formData.name}
                  onChange={onInputChange}
                  type="text"
                  required
                  className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-purpleColor"
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2">
                  Country
                </label>
                                 <Select
                   name="country_id"
                   value={countriesData?.find(country => country.id === formData.country_id) ? {
                     value: formData.country_id,
                     label: countriesData.find(country => country.id === formData.country_id)?.name
                   } : null}
                   onChange={(selectedOption) => {
                     console.log('Selected option:', selectedOption);
                     onInputChange({
                       target: {
                         name: 'country_id',
                         value: selectedOption ? selectedOption.value : ''
                       }
                     });
                   }}
                   options={countriesData?.map((country) => ({
                     value: country.id,
                     label: country.name
                   })) || []}
                   placeholder="Select a Country"
                   isClearable
                   isSearchable
                   className="w-full"
                   classNamePrefix="react-select"
                   styles={selectStyles}
                 />
              </div>
            </div>
            <div className="flex justify-end gap-4 mt-6 p-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blueColor text-white rounded"
              >
                Add
              </button>
            </div>
          </DialogContent>
        </form>
      </Dialog>
    </div>
  );
}

export default CityForm;